import React, { useState } from 'react'
import { Typography, Grid, Container, IconButton, TextField, Button } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PinDropIcon from '@mui/icons-material/PinDrop';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Helmet } from "react-helmet-async";


const Contact = () => {
  const [contact, setContact] = useState({name: '', email: '', subject: '', message: ''})

  const backend = 'https://oureclecticsociety.org/core'
  const frontend = 'https://oureclecticsociety.com/'

  const handleSubmit = (e) => {
    e.preventDefault()

    if(contact){

      fetch(`${backend}/contact-create/`, {
        method : 'POST',
        headers : {"Content-type": "application/json"},
        body: JSON.stringify(contact)
      })

    }
    else{
      setContact({name: '', email: '', subject: '', message: ''})
    }
    
    window.location.reload()
     
  }

  return (
    <Container>

      <Helmet>
        <title>OES | Contact</title>
        <meta name="description"
          content="Reach out to OurEclecticSociety for comments and a chance to partake
          in our discussions" />
        <meta
          name="keywords"
          content="African, Nairobi, Growth, Economy, Culture, History, Politics, Society, Eclectic"
        />
        <meta property="og:title" content="Our Eclectic Society" />
        <meta property="og:description" content="Mindful thoughts and discussions about our continent" />
        {/* <meta property="og:image" content={img1} />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" /> */}
        <link rel="canonical" href="/contact" />
      </Helmet>

      <Grid container spacing={4} sx={{ mt: 6, mb: 3, px: 2}}>
        <Grid xs={12} md={6} sx={{p:1 }}>
          <Typography variant="h4" sx={{pb:3}}>Contact Us</Typography>
          <Typography variant="h6" sx={{pb:3}}>
            What would you like us to discuss next?
            Send us an email or dm us on our socials.
            We are happy to hear from you... &#128515;
          </Typography>
          {/* <p>
            <IconButton >
              <PhoneIcon sx={{color:'red', mr: 2}} />
              <Typography>+254 714859324</Typography>
            </IconButton>
          </p> */}
          <p>
            <IconButton >
              <EmailIcon sx={{color:'red', mr: 2}} />
              <Typography>oursociety.2022@gmail.com</Typography>
            </IconButton>
          </p>
          <p>
            <IconButton >
              <PinDropIcon sx={{color:'red', mr: 2}}/>
              <Typography>Tivoli Centre, Kisumu City</Typography>
            </IconButton>
          </p>

          <Typography variant="h4" sx={{pb:3}}>Follow Us</Typography>
          <IconButton sx={{color:'blue'}}><FacebookIcon /></IconButton>
          <IconButton sx={{color:'blue'}}><TwitterIcon /></IconButton>
          <IconButton sx={{color:'purple'}}><InstagramIcon /></IconButton>
        </Grid>

        <Grid xs={12} md={6} sx={{p:1 }}>
          <form noValidate onSubmit={handleSubmit}>
            <Typography>Name*</Typography>
            <TextField onChange={(e) => setContact({...contact, name: e.target.value}) } label="Name" variant="outlined" fullWidth/>
            <Typography>Email*</Typography>
            <TextField onChange={(e) => setContact({...contact, email: e.target.value}) } label="Email" variant="outlined" fullWidth/>
            <Typography>Subject*</Typography>
            <TextField onChange={(e) => setContact({...contact, subject: e.target.value}) } label="Subject" variant="outlined" fullWidth/>
            <Typography>Message*</Typography>
            <TextField onChange={(e) => setContact({...contact, message: e.target.value}) } label="Anything to say...?" variant="outlined" fullWidth/>
            <Button sx={{ mt: 3 }} type="submit" variant="contained" endIcon={<EditNoteIcon />}>Submit</Button>
          </form>
        </Grid>

      </Grid>  
    </Container>
  )
}

export default Contact
